import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { useMemo, useRef, useState } from 'react';
import { classNames } from 'primereact/utils';
import { useForm, Controller } from 'react-hook-form';
import { InputTextarea } from 'primereact/inputtextarea';
import { useZonesQuery, useAddDomainesMutation, useExistDomaineMutation, useDomainesQuery } from '../../cdsApiSlice';
import { Toast } from 'primereact/toast';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useAppDispatch, useAppSelector } from '../../../../hooks/hooks';
import { setDomainePagination } from '../../cdsSlice';
import { useGetConfigQuery } from '../../../../app/apiSlice';

interface Props {
  setter: () => void;
  add: (param: any) => void;
  displayCreateDomaineDialog: boolean;
}

export const Domaine = ({ setter, displayCreateDomaineDialog, add }: Props) => {
  const toast: any = useRef(null);
  const {data : config} = useGetConfigQuery();
  const [getExistDomaine,] = useExistDomaineMutation();
  const { data: zones, } = useZonesQuery();
  const [addDomaine, statusDomaine] = useAddDomainesMutation();
  const [duplicatedValue,setDuplicatedValue] = useState<boolean>(false);
  const pagination = useAppSelector((state) => state.cds.domainePagination)
  const { data: domains, } = useDomainesQuery(pagination);
  const dispatch = useAppDispatch()


  const defaultValues: {
    name:string,
    description:string
  } = {
    name: "",
    description: "",
  };

  const zone = useMemo(() => {
    if (zones && zones.length == 1) {
       return zones[0]
    }
    return undefined
  },[zones])

  const {
    control,
    formState: { errors },
    handleSubmit,
    reset,
    setValue,
    getValues,
  } = useForm({ defaultValues });

  const errorDomain = ():void => {
    toast.current.show({
      severity: 'error',
      summary: 'Domaine',
      detail: `Erreur ! Domaine non ajouté !`,
      life: 3000,
    });
  }

  const onSubmitHandler = async (data: any) => {

    //check if the zone is known

    try {
      // Test if domain name not added by another user in parallel
      const alreadyExists = await getExistDomaine({value: data.name}).unwrap();
      if (alreadyExists > 0) {
        setDuplicatedValue(true)
      } else {
        const domaineAdded = await addDomaine({
          libelle: data.name,
          description: data.description,
          zone: config && config.realm !== "" ? config.realm : 'technique',
        }).unwrap();

        if (domaineAdded) {
          toast.current.show({
            severity: 'success',
            summary: 'Domaine',
            detail: `Domaine ${getValues('name')} ajouté !`,
            life: 3000,
          });
          add({nom: domaineAdded.libelle, id: domaineAdded.id})
          setter();
          reset();
          if(domains && pagination.size !== 0) {
            const ratio = (domains.total + 1)/pagination.size
            const lastPage = Math.ceil(ratio !== 0 ? ratio - 1 : ratio)
            dispatch(setDomainePagination({
              ...pagination,
              page:lastPage
            }));
          }
        } else {
          
        }
      }
    } catch {
      errorDomain()
    }
  };

  const footerDialog = () => {
    return (
      <>
        <Button
          label={"ANNULER"}
          disabled={false}
          onClick={() => {
            setter()
            reset()
          }}
          className="mr-3 p-button-outlined p-button-sm"
        />

        <Button
          id="hook-form"
          onClick={() => {
            handleSubmit(onSubmitHandler)();
          }}
          type="submit"
          label={"CRÉER"}
          className="p-button p-button-sm"
        >
          {statusDomaine.isLoading ? <FontAwesomeIcon className="ml-2" icon="spinner" spin /> : null }
          </Button>
      </>
    );
  };

  return (
    <>
      <Toast ref={toast} />

      <Dialog
        header={"Créer un nouveau domaine"}
        footer={footerDialog}
        draggable={false}
        visible={displayCreateDomaineDialog}
        style={{ width: "25vw" }}
        modal
        onHide={() => {
          setDuplicatedValue(false);
          setter();
          reset();
        }}
      >
        <form id="hook-form" onSubmit={handleSubmit(onSubmitHandler)}>
          <div className="field">
            <div className="grid p-fluid">
              <div className="col-8 p-field mt-2 w-full">
                <div className="field mb-2 mt-3">
                  <span className="p-float-label">
                    <Controller
                      name="name"
                      control={control}
                      rules={{ required: true }}
                      render={({ field, fieldState }) => (
                        <InputText
                          id={field.name}
                          {...field}
                          autoFocus
                          className={classNames({
                            "p-invalid": fieldState.invalid,
                          })}
                        />
                      )}
                    />
                    <label
                      htmlFor="name"
                      className={classNames({ "p-error": errors.name || duplicatedValue })}
                    >
                      Nom*
                    </label>
                  </span>
                  {duplicatedValue ? ( <small className="p-error">Nom de domaine déjà existant</small>) : ""}
                </div>
              </div>
              <div className="col-8 p-field mt-2 w-full">
                <div className="field mb-2 mt-3">
                  <span className="p-float-label">
                    <Controller
                      name="description"
                      control={control}
                      render={({ field, fieldState }) => (
                        <InputTextarea id={field.name} {...field} />
                      )}
                    />
                    <label htmlFor="description">Description</label>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </form>
      </Dialog>
    </>
  );
};
